import React, { useEffect } from 'react';
import { Form, Button, Card, Row, Col, Typography, Divider, Switch } from 'antd';
import UserPermissionEditor from '../../permissions/UserPermissionEditor';
import { useUpdateUser, useFetchUserById } from '../../hooks/userHooks';

const { Title, Text } = Typography;

const UserUpdateForm = ({ userId,onFinishedUpdate, onUserModified }) => {
  const { user, loading, error } = useFetchUserById(userId);
  const { handleUpdate } = useUpdateUser();
  const [form] = Form.useForm();

  useEffect(() => {
    if (user) {
      form.setFieldsValue(user);
    }
  }, [user, form]);

  const onFinish = async (values) => {
    await handleUpdate(userId, { ...values, PermissionSettings: form.getFieldValue('PermissionSettings') });
    window.dispatchEvent(new Event('permissions-refresh'));
    window.dispatchEvent(new Event('permission-memberships-changed'));
    (onFinishedUpdate || onUserModified)?.();
  };

  if (loading) return <Typography.Text>Loading...</Typography.Text>;
  if (error) return <Typography.Text type="danger">Error: {error}</Typography.Text>;

  return (
    <Card bordered={false} style={{ maxWidth: 1100, margin: '20px auto' }}>
      <Title level={4}>Update User</Title>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Row gutter={24}>
          <Col span={24}>
            <Card size="small" style={{ backgroundColor: '#f5f5f5' }}>
              <Title level={5}>Informations Utilisateur</Title>
              <Form.Item name="IsManager" label="Manager" valuePropName="checked">
                <Switch />
              </Form.Item>
              <Text strong>User ID:</Text>
              <Text block style={{ marginBottom: 12 }}>{user?.UserID}</Text>
              
              <Text strong>Email:</Text>
              <Text block style={{ marginBottom: 12 }}>{user?.Email}</Text>
              
              <Text strong>Name:</Text>
              <Text block>{user?.Name}</Text>
            </Card>
          </Col>
          <Col span={24} style={{ marginTop: 20 }}>
            <Title level={5}>Permissions</Title>
            <UserPermissionEditor />
          </Col>
        </Row>
        <Divider />
        <Row justify="end">
          <Col>
            <Button type="primary" htmlType="submit" size="large">
              Update User
            </Button>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default UserUpdateForm;
